<template>
  <div class="section-container">
    <div class="section-top">
      <div class="flex items-center">
        <p class="section-title mr-3">{{ title }}</p>
        <sf-icon @click="openModal" size="lg" :icon="['fas', 'info-circle']" :style="{ cursor: 'pointer', marginTop: '-3px' }" />
      </div>
      <p class="section-number">{{ step }}/{{ totalSteps }}</p>
    </div>
    <div class="section-bottom">
      <ul v-for="category in categories" :key="category" class="mb-12 last:mb-4">
        <li
          v-if="sortedOptions[category]"
          class="flex flex-col lg:flex-row lg:justify-between mb-4"
          v-html="categoryContent[category]"
        ></li>
        <li
          v-for="option in sortedOptions[category]"
          :key="option.id"
          @click="setSelection(option)"
          class="list-select-item"
          :class="{ 'selected-list-select-item': isSelected(option) }"
        >
          <p>{{ option.variationName || option.name || "" }}</p>
          <p v-if="priceDifference(option)" class="font-bold bg-yellow-300 py-1 px-2 min-w-[112px] text-right">
            <span class="mr-1">{{ priceDifference(option) > 0 ? "+" : "-" }}</span
            >{{ Math.abs(priceDifference(option)) | formatPrice }} €
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getAttributeValue } from "./plentyHelpers";
import { fetchCategoryContent } from "./Helpers";

export default {
  name: "Attachement",

  props: ["category", "step", "totalSteps"],

  data() {
    return {
      modalContent: "",
      title: "Befestigung",
      categoryContent: {},
    };
  },

  async created() {
    let { modalContent, title, cardContent } = await this.fetchCategoryContent(this.category, this.$setPreview);
    this.modalContent = modalContent;
    if (title) this.title = title;

    if (cardContent) {
      let dom = document.createElement("div");
      dom.innerHTML = cardContent;

      let items = dom.querySelectorAll("li");
      let categoryContent = {};

      for (const item of items) {
        let categoryName = item.getAttribute("data-category");
        let markup = item.innerHTML;

        categoryContent[categoryName] = markup;
      }

      this.categoryContent = categoryContent;
    }
  },

  computed: {
    ...mapState("attachement/", {
      options: (state) => state.options,
      selection: (state) => state.selection,
      defaultSelection: (state) => state.defaultSelection,
    }),

    arms() {
      return this.$store.getters["dimensions/numberOfArms"];
    },

    setItemId() {
      return this.$store.state.set.setItem.id;
    },

    sortedOptions() {
      let byCategory = {};
      if (this.options.length < 1) return [];
      let options = this.options;

      options = options.filter((option) => {
        let intendedForArms = getAttributeValue(option, "Arme");
        return this.arms == intendedForArms;
      });

      options.forEach((option) => {
        let category = getAttributeValue(option, "Befestigung");

        // Filter out categories that are not available for the set
        // No Dachsparrenhalterung option for B50 and B50XL
        if ((this.setItemId == 950 || this.setItemId == 951) && category == "Dachsparrenhalterung") return;

        if (!byCategory[category]) {
          byCategory[category] = [];
        }

        byCategory[category].push(option);
      });

      return byCategory;
    },

    categories() {
      return ["Wandhalterung", "Wandhalterung für WDVS", "Deckenhalterung", "Dachsparrenhalterung"];
    },
  },

  methods: {
    ...mapMutations("attachement/", {
      setSelection: "setSelection",
    }),

    getAttributeValue,
    fetchCategoryContent,

    isSelected(option) {
      return this.selection.id === option.id;
    },

    priceDifference(option) {
      if (!this.selection) return 0;
      if (!this.selection.variationSalesPrices) return 0;

      let optionPrice = option.variationSalesPrices[0].price;
      let selectedPrice = this.selection.variationSalesPrices[0].price;
      return optionPrice - selectedPrice;
    },

    openModal() {
      this.$store.commit("modal/openModal")
      this.$store.dispatch("modal/setBody", this.modalContent);
      this.$store.dispatch("modal/setTitle", this.title);
    },
  },
};
</script>

<style></style>
